import { carBrandcodes } from '../../constants';
import { getResultsScreenDisplayMode } from '../../../utils/displayMode';

export const footerDisclaimer = ({ fsgUrl }) => {
    return `<p>The financial services provided in this comparison are provided by Compare the Market Pty Ltd ACN 117 323 378 AFSL 422926 (CTM)
               acting as a representative of iSelect General Pty Limited ABN 90 131 798 126 AFSL 334115 (iSelect).</p>
           <p>Any quotes provided on the comparison results pages, are indicative and subject to change based on further questions asked by the insurer.</p>
           <p>The website does not compare all car insurers or products in the market. Any advice given is general advice only and does not take into account your 
              objectives, financial situation or needs. You should consider whether the advice is suitable for you and your personal circumstances, 
              and before you make any decision about whether to purchase a product, you should read the PDS for that product.</p>
           <p>For more information about the range of insurers and products compared, how the service works (including management of conflicts of interest), 
              and how CTM and iSelect make money (remembering that the service is free for you to use) read the
             <a href="${fsgUrl}" target="_blank">Financial Services Guide (Car and Home Insurance Products)</a>.
             A number of the car insurance brands compared on the panel are arranged by Auto & General Services Pty Ltd ACN 003 617 909 on behalf 
             of the insurer Auto & General Insurance Company Limited ACN 111 586 353, both of which are related entities of CTM and iSelect. 
             Our relationship with those companies does not impact the integrity of the comparison service, and we continue to work hard to 
             encourage brands that do not currently participate on our comparison service to come on board.</p>
           <p>Vehicle information has been provided by <a id="redbookDisclosureOpen" data-id="redbookDisclosureOpen">Red Book</a>.</p>`;
};

export const trustedPartnerContent = () => {
    const trustedPartnerConfig = {
        title: 'Trusted Partners',
        description: 'Trusted Partners, for the purpose of your invitation to call, are:',
        reasons: [
            'the insurer that ranks in position 1 on the results page;',
            'any other insurer with whom you express an interest to contact, by commencing an online application or enquiry.'
        ]
    };
    return trustedPartnerConfig;
};

export const redbookDisclosureContent = () => {
    const redbookDisclosureConfig = {
        title: 'Vehicle Information Provided by Red Book',
        description: 'Vehicle information has been provided by Automotive Data Services Pty Ltd (Red Book). Red Book has prepared this '
            + 'data and valuations from information gathered from a variety of sources. Whilst all care has been taken in producing the '
            + 'data and valuations, Red Book cannot guarantee or make any representations regarding the use of, or reliance, on it. '
            + 'Red Book is not responsible for all the information provided to it and you should not rely on the data or valuations '
            + 'without making your own independent assessment for the vehicle and other sources of information. Red Book is not liable '
            + 'for any loss or damages (other than in respect of any liability which may not lawfully be excluded) relating to your use of, '
            + 'reliance on, this valuation and data.'
    };
    return redbookDisclosureConfig;
};

export const partnerBrands = () => [
    carBrandcodes.BUDD,
    carBrandcodes.EXOA,
    carBrandcodes.HUDD,
    carBrandcodes.OZIC,
    carBrandcodes.WOOL,
    carBrandcodes.STEL,
    carBrandcodes.AHM,
    carBrandcodes.EXCL
    // todo: Uncomment for BUPA go-live
    // carBrandcodes.BUPA,
];

export const crossSellOtherVerticalsOnResults = () => false;
export const spinnerColour = () => '#FE5A19';
export const showNoResultsOverlayGenericMessage = () => true;
export const resultsScreenDefaultDisplayMode = (hasSavedResults, experimentId) => {
    return getResultsScreenDisplayMode(hasSavedResults, experimentId);
};

export const contactDetailOptInPrivacyMessage = ({ companyName, fsgUrl, privacyPolicyUrl }) => {
    return `I have read and accept the <a href='${privacyPolicyUrl}' target="_blank" data-id="websitePrivacyCollectionNoticeLink" rel="noopener noreferrer">Privacy Collection Notice</a>
    and <a href='${fsgUrl}' target="_blank" data-id="websiteFinancialServicesGuideLink" rel="noopener noreferrer">Financial Services Guides (A & B)</a>,
    including that ${companyName} or its representatives may email and SMS me about the services it provides. By providing a contact number,
    I invite them or their <a id="trustedPartnersOpen" data-id="trustedPartnersOpen">Trusted Partners</a> to call me during the call centre
    <a id="callCentreHoursOpen" data-id="callCentreHoursOpen">opening hours</a> to discuss the potential purchase of a car insurance policy.`;
};

export const enableResultsFeatureAccordion = () => true;
export const showPriceConfidenceBanner = () => false;
export const spinnerType = () => 'Default';
